import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsSectionLink from '../APIDocsSectionLink';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsCreatePostBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Create post</div>
          <div className="text">Creates a new post.</div>
          <div className="text">
            {'You may also want to use the '}
            <APIDocsSectionLink
              sectionID="create_or_update_user"
              onScrollToSection={this.props.onScrollToSection}
            />
            {" endpoint to make sure the post author's account exists (and fetch their id)."}
          </div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                description: 'Your secret API key.',
                heading: 'apiKey',
                subheading: 'string',
              },
              {
                description: "The unique identifier of the post's author.",
                heading: 'authorID',
                subheading: 'string',
              },
              {
                description: "The unique identifier of the post's board.",
                heading: 'boardID',
                subheading: 'string',
              },
              {
                description:
                  'The identifier of the admin who creates the post on behalf of the author. This will be visible in the post.',
                heading: 'byID',
                subheading: 'string (optional)',
              },
              {
                description: "The unique identifier of the post's category or subcategory.",
                heading: 'categoryID',
                subheading: 'string (optional)',
              },
              {
                description:
                  'Any custom fields associated with the post. Each field name (key) must be between 0 and 30 characters long. If field values are strings, they must be less than 200 characters long.',
                heading: 'customFields',
                subheading: 'object (optional)',
              },
              {
                description: 'The post details.',
                heading: 'details',
                subheading: 'string',
              },
              {
                description:
                  "The estimated date of the post's completion. In the format of MM/YYYY, eg, 06/2022.",
                heading: 'eta',
                subheading: 'string (optional)',
              },
              {
                description: 'If the ETA should be made visible to all users.',
                heading: 'etaPublic',
                subheading: 'boolean (optional)',
              },
              {
                description: 'The post title.',
                heading: 'title',
                subheading: 'string',
              },
              {
                description:
                  'The ID of the user responsible for the completion of the work described in the post.',
                heading: 'ownerID',
                subheading: 'string (optional)',
              },
              {
                description: "An array of the URLs of post's images.",
                heading: 'imageURLs',
                subheading: 'array (optional)',
              },
              {
                description:
                  'If the post is being moved from another source, the date this post was originally created in ISO 8601 format.',
                heading: 'createdAt',
                subheading: 'string (optional)',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">Upon success, returns an object with a single key: id.</div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/posts/create</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/posts/create"
            body={`-d '{
    "apiKey": "YOUR_API_KEY",
    "authorID": "553c3ef8b8cdcd1501ba1238",
    "boardID": "553c3ef8b8cdcd1501ba1234",
    "customFields": {
      "number": 12,
      "string": "value"
    },
    "details": "This is the post's details",
    "title": "Post Title"}' \\
    -H "Content-Type: application/json"`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">
            {`{
  "id": "553c3ef8b8cdcd1501ba1240",
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
